import {ReactNode} from "react";
import {Button, Modal, ModalContent, ModalFooterButtons} from "@reside/ui";

type Props = Readonly<{
  title: string;
  isOpen: boolean;
  isDeleting: boolean;
  onConfirm: () => void;
  onClose: () => void;
  children: ReactNode;
}>;

export const ConfirmDeleteModal = ({
  title,
  isOpen,
  isDeleting,
  onConfirm,
  onClose,
  children,
}: Props) => (
  <Modal title={title} isOpen={isOpen} onRequestClose={onClose}>
    {() => (
      <>
        <ModalContent>{children}</ModalContent>
        <ModalFooterButtons>
          <Button onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button color="danger" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
        </ModalFooterButtons>
      </>
    )}
  </Modal>
);
